import { request } from "@/utils/response";
/**
 * 删除工作经历
 */
export const deleteWorkExpr = (id) => {
    return request(`/v1/user/delete/workexpr`, {
        data: { id },
        method: "POST",
    });
};
/**
 * 编辑工作经历
 */
export const editWorkExpr = (data) => {
    return request(`/v1/user/edit/workexpr`, {
        data,
        method: "POST",
    });
};
/**
 * 头像上传
 */
export const uploadAvatar = (data) => {
    return request(`/v1/user/account/edit_avatar`, {
        data,
        method: "POST",
    });
};
/**
 * 获取用户在线简历信息
 */
export const getUserOnlineResume = () => {
    return request(`/v1/user/online_resume`, {
        method: "POST",
    });
};
/**
 * 修改用户在线简历信息
 */
export const editUserOnlineResume = (data) => {
    return request(`/v1/user/account/edit`, {
        method: "POST",
        data,
    });
};
/**
 * 设置求职状态
 */
export const setSeekingStatus = (statusId) => {
    return request(`/v1/user/edit/empstatus`, {
        method: "POST",
        data: { statusId },
    });
};
/**
 * 设置教育经历
 */
export const setEducation = (data) => {
    return request(`/v1/user/educationExperience`, {
        method: "POST",
        data,
    });
};
/**
 * 删除教育经历
 */
export const deleteEducation = (id) => {
    return request(`/v1/user/deleteEducationExperience`, {
        method: "POST",
        data: { id },
    });
};
/**
 * 设置教育经历
 */
export const setJobintention = (data) => {
    return request(`/v1/edit/jobintention`, {
        method: "POST",
        data,
    });
};
/**
 * 设置求职期望
 */
export const setSeeking = (data) => {
    return request(`/v1/user/edit/jobintention`, {
        method: "POST",
        data,
    });
};
/**
 * 删除求职期望
 */
export const deleteSeeking = (id) => {
    return request(`/v1/user/delete/jobintention`, {
        method: "POST",
        data: { id },
    });
};
/**
 * 设置个人优势
 */
export const setPersonality = (description) => {
    return request(`/v1/user/edit/advantages`, {
        method: "POST",
        data: { description },
    });
};
/**
 * 获取个人下拉菜单信息-求职状态
 */
export const getSystemConfigKV = () => {
    return request(`/v1/user/data/systemConfigKV`, {
        method: "POST",
    });
};
/**
 * 获取行业配置
 */
export const getIndustryConfigKV = () => {
    return request(`/v1/user/data/allIndustryPC`, {
        method: "POST",
    });
};
/**
 * 编辑项目经历
 */
export const editProExpr = (data) => {
    return request(`/v1/user/edit/prgexpr`, {
        data,
        method: "POST",
    });
};
/**
 * 编辑培训经历
 */
export const editTrainExpr = (data) => {
    return request(`/v1/user/trainingExperience`, {
        data,
        method: "POST",
    });
};
/**
 * 编辑语言
 */
export const editLanguage = (data) => {
    return request(`/v1/user/languageAbility`, {
        data,
        method: "POST",
    });
};
/**
 * 编辑技能
 */
export const editSkill = (data) => {
    return request(`/v1/user/professionalSkills`, {
        data,
        method: "POST",
    });
};
/**
 * 删除技能
 */
export const deleteSkill = (id) => {
    return request(`/v1/user/deleteProfessionalSkills`, {
        method: "POST",
        data: { id },
    });
};
/**
 * 删除语言
 */
export const deleteLanguage = (id) => {
    return request(`/v1/user/deleteLanguageAbility`, {
        method: "POST",
        data: { id },
    });
};
/**
 * 删除项目经验
 */
export const deleteProExpr = (id) => {
    return request(`/v1/user/delete/prgexpr`, {
        method: "POST",
        data: { id },
    });
};
/**
 * 删除培训经历
 */
export const deleteTrainExpr = (id) => {
    return request(`/v1/user/deleteTrainingExperience`, {
        method: "POST",
        data: { id },
    });
};
/**
 * 删除个人作品
 */
export const deletePersonalWork = (id) => {
    return request(`/v1/user/deletePersonalWork`, {
        method: "POST",
        data: { id },
    });
};
/**
 * 编辑个人作品
 */
export const editPersonalWork = (data) => {
    return request(`/v1/user/personalWork`, {
        data,
        method: "POST",
    });
};
//上传个人作品
export async function UploadPersonalImage(data) {
    return request(`/v1/media/upload/file`, {
        method: "POST",
        data: data,
        arguments: {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            prefix: "/media",
        },
    });
}
